<template>
    <div class="ebc-rule-list">
        <template v-for="(item, index) in dataList">
            <div class="ebc-rule-item" :class="{ 'ebc-rule-content-show': item.show }">
                <div class="ebc-rule-text-label" @click="showUl(item, index)">{{ item.label }}</div>
                <div class="ebc-rule-text-ul" :ref="'ebc-rule-text-ul-' + index"
                    :style="{ maxHeight: item.maxHeight + 'px' }">
                    <div class="ebc-rule-text-li" v-for="(li, i) in item.ul" :key="i" v-html="li">
                    </div>
                </div>
            </div>
            <div class="ebc-rule-item-line"></div>
        </template>
    </div>
</template>

<script>
export default {
    name: "ebc-rule-list",
    props: {
        ruleList: {
            default: () => {
                return []
            }
        }
    },
    data() {
        return {
            dataList: []
        }
    },
    mounted() {
        this.dataList = this.ruleList.map(item => {
            return {
                show: false,
                maxHeight: 0,
                ...item,
            }
        })
        this.dataList.forEach((item, index) => {
            const ulRef = this.$refs[`ebc-rule-text-ul-${index}`];
            if (ulRef && item.show) {
                const el = ulRef[0];
                item.maxHeight = el.scrollHeight;
            }
        });
    },
    methods: {
        async showUl(item, index) {
            const ulRef = this.$refs[`ebc-rule-text-ul-${index}`][0]; // 获取 DOM 元素

            if (item.show) {
                // 收起状态
                item.maxHeight = 0;
                item.show = false;
            } else {
                // 展开：先临时设置为高度 auto 获取 scrollHeight
                item.show = true;
                item.maxHeight = 0;

                // 等待 DOM 更新，获取真实 scrollHeight
                await this.$nextTick();
                const scrollHeight = ulRef.scrollHeight;

                // 开启动画
                item.maxHeight = scrollHeight;
            }
        }
    }
}
</script>

<style lang="scss">
.ebc-rule-list {
    .section4-form-btn {
        color: #a52933;
        text-decoration: underline;
    }

    .section4-form-btn:hover {
        color: #a52933;
    }
}
</style>
<style scoped>
/* 规则列表开始 */
.ebc-rule-list {
    margin-top: 80rem;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    /* gap: 24rem; */
}

.ebc-rule-item {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 8rem;
    width: 100%;
}

.ebc-rule-item-line {
    margin-top: 16rem;
    margin-bottom: 24rem;
    height: 1px;
    width: 100%;
    background: #ebebeb;
}

.ebc-rule-text-label {
    position: relative;
    width: 100%;
    color: var(--Text-Primary, #000);
    font-size: 24rem;
    font-style: normal;
    font-weight: 500;
    line-height: 1.5;
    cursor: pointer;
}

.ebc-rule-text-label::after {
    position: absolute;
    right: 0;
    content: "\e62d";
    font-family: "iconfont" !important;
    font-size: 24rem;
    line-height: 1.5;
}

.ebc-rule-content-show .ebc-rule-text-label::after {
    content: "\e62b";
}

.ar .ebc-rule-text-label::after {
    right: unset;
    left: 0;
}

.ebc-rule-text-ul {
    max-height: 0;
    opacity: 0;
    overflow: hidden;
    transition: max-height 0.4s ease, opacity 0.3s ease;
}

.ebc-rule-content-show .ebc-rule-text-ul {
    opacity: 1;
}

.ebc-rule-text-li {
    color: var(--Text-Secondary, rgba(0, 0, 0, 0.64));
    font-size: 16rem;
    font-style: normal;
    font-weight: 400;
    line-height: 1.75;
}

.ebc-rule-text-li::before {
    content: "•";
    font-weight: bold;
    flex-shrink: 0;
    line-height: 1.75;
}

.ebc-rule-text-li+.ebc-rule-text-li {
    margin-top: 8rem;
}

.ebc-rule-text-value a:hover,
.ebc-rule-text-value a {
    color: var(--Text-Secondary, rgba(0, 0, 0, 0.64));
}

.ebc-rule-list[data-white] .ebc-rule-text-label， .ebc-rule-list[data-white] .ebc-rule-text-li {
    color: var(--Text-Primary, #fff);
}


@media (max-width: 996px) {
    .ebc-rule-list {
        /* gap: 48rem; */
    }

    .ebc-rule-item-line {
        margin-top: 32rem;
        margin-bottom: 48rem;
    }

    .ebc-rule-item {
        gap: 16rem;
    }

    .ebc-rule-text-label {
        font-size: 32rem;
    }

    .ebc-rule-text-li {
        font-size: 28rem;
        line-height: 44rem;
    }

    .ebc-rule-text-li+.ebc-rule-text-li {
        margin-top: 16rem;
    }

    .ebc-rule-text-label::after {
        font-size: 32rem;
    }
}
</style>